import "core-js/modules/es.array.map";
import * as React from 'react';
import classNames from 'classnames';
import Line from "./Line";
import TextAligner from "./TextAligner";

var AlignInfo = function AlignInfo(_ref) {
  var _ref$boundary = _ref.boundary,
      boundary = _ref$boundary === void 0 ? true : _ref$boundary,
      height = _ref.height,
      _ref$lines = _ref.lines,
      lines = _ref$lines === void 0 ? [] : _ref$lines;
  var overlayClasses = classNames('AlignInfo-overlay', {
    'AlignInfo-overlay--boundary': boundary
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "AlignInfo"
  }, /*#__PURE__*/React.createElement("div", {
    className: overlayClasses
  }, /*#__PURE__*/React.createElement(TextAligner, null), lines.map(function (strategy, i) {
    return /*#__PURE__*/React.createElement(Line, {
      key: i,
      strategy: strategy
    });
  })));
};

export default AlignInfo;